export const parseKonfirCallbackState = (
  state: string | null
): {
  caseId?: string;
  section?: string;
} => {
  if (!state) return {};

  try {
    return JSON.parse(state);
  } catch {
    return {};
  }
};
